import { defineComponent as _defineComponent } from 'vue'
import {onMounted, ref, Ref} from 'vue'
import {AttachmentModel} from "@/services/models/entities/attachments";
import {recognitionDataDto2Model} from "@/features/call2text/model";
import {PhraseSttData} from "@/features/call2text/types";
import {emitSetTimeEvent} from "@/components/player2/audioPlayerEvents";


export default /*#__PURE__*/_defineComponent({
  __name: 'CallSttResults',
  props: {
    attachment: null
  },
  emits: ["click:item"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'click:item', target: EventTarget, data: PhraseSttData)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  attachment: AttachmentModel
}





const phrases: Ref<PhraseSttData[]> = ref([])

function handleItemClick(event: PointerEvent, data: PhraseSttData) {
  emitSetTimeEvent({
    id: props.attachment.id,
    time: data.start
  })
  emits('click:item', event.target, data)
}

onMounted(() => {
  if (props.attachment.sttResults) {
    phrases.value = props.attachment.sttResults.map(recognitionDataDto2Model).filter(i => i !== null)
  }
})

return { __sfc: true,props, emits, phrases, handleItemClick }
}

})